import { createPhoneAuthClient } from "@benyishiguang/ui-foundation";
import { saveUserSession, type UserSession } from "./auth-session";
export const phoneAuth = createPhoneAuthClient(import.meta.env.VITE_API_BASE_URL || "/api/v1");
export const refreshUserSession = async (current: UserSession): Promise<UserSession> => {
	const session = await phoneAuth.session(current.token);
	saveUserSession(session);
	return session;
};
